import PropTypes from 'prop-types';

const ToggleComponent = ({ check, children }) => (check ? <>{ children }</> : null);

ToggleComponent.defaultProps = {
  check: false,
};

ToggleComponent.propTypes = {
  check: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
  ]).isRequired,
};

export default ToggleComponent;